var styles = ["[_ngcontent-%COMP%]:not(button){font-size:.7rem;line-height:.7rem}"];
export { styles as styles };
